import {appConfigService} from '_app/services';

export default (function () {
	var baseUrl = 'api/v1';

	function call(method, url, data, options) {
		var dfd = $.Deferred();
		var fullUrl = rootUrl() + url;
		var	defaultOptions = {
			'cache': false,
			'data': data,
			'method': method,
			'traditional': true,
			'global': false,
			'contentType': 'application/json; charset=utf-8',
			'xhrFields': {
				withCredentials: isInternalUpload(fullUrl)
			}
		};
		var	ajaxOptions = $.extend(true, defaultOptions, options || {});

		$.ajax(fullUrl, ajaxOptions)
			.done(function () {
				dfd.resolveWith(this, arguments);
			})
			.fail(errorHandler(dfd));

		return dfd.promise();
	}

	function uploadFile(data, url, dataName) {
		var formData = new FormData();
		var options = {
			url: url,
			type: 'POST',
			data: formData,
			cache: false,
			contentType: false,
			processData: false,
			xhrFields: {
				withCredentials: isInternalUpload(url)
			}
		};
		var dfd = $.Deferred();

		formData.append(dataName, data, data.name);

		$.ajax(options)
			.done(function() {
				dfd.resolveWith(this, arguments);
			})
			.fail(errorHandler(dfd));

		return dfd.promise();
	}

	function isInternalUpload(url) {
		var serverPath = appConfigService.get('serverPath');

		return serverPath
			&& url
			&& (url.startsWith(serverPath));
	}

	function upload(data, url, isPublic) {
		var fullUrl = rootUrl() + url + '?isPublic=' + (isPublic ? 'true' : 'false');

		return uploadFile(data, fullUrl, 'payload');
	}

	// Returns a function to handle ajax errors and rejects the passed in
	// Deferred.
	function errorHandler(dfd) {
		return function(jqXHR) {
			var scope = this;
			var message = '';
			var errors = null;
			var jsonResponse = jqXHR.responseJSON && jqXHR.responseJSON instanceof Object;

			if (jsonResponse && 'Message' in jqXHR.responseJSON) {
				message = jqXHR.responseJSON.Message;
			}
			if (jsonResponse && 'Errors' in jqXHR.responseJSON) {
				errors = jqXHR.responseJSON.Errors;
			}
			message = !message.length ? 'Unknown error encountered' : message;
			dfd.rejectWith(scope, [jqXHR, message, errors]);
		};
	}

	function getParsed(url, options) {
		return call('GET', url, '')
			.then(function(data) {
				parse(data, options);
				return data;
			});
	}

	// Data is expected to be an array
	function getParsedArray(url, options) {
		return call('GET', url, '')
			.then(function(data) {
				if (data instanceof Array) {
					for (let i = 0; i < data.length; i++) {
						parse(data[i], options);
					}
				}
				return data;
			});
	}

	/**
	 * Utility to parse json into certain data types. options defines
	 * the fields in data to parse.
	 * @param {object} data
	 * @param {object} options
	 */
	function parse(data, options) {
		options = options || {};
		options.datetimes = options.datetimes || [];
		options.floats = options.floats || [];
		options.dates = options.dates || [];
		// eslint-disable-next-line no-unused-vars
		for (const property in data) {
			if (data[property] === null) {
				continue;
			}
			if (options.floats.indexOf(property) !== -1) {
				data[property] = parseFloat(data[property]);
			}
			if (options.dates.indexOf(property) !== -1) {
				const date = new Date(data[property]);

				// This step is necessary to convert the time so that date displays
				// correctly, since javascript automatically adds time.
				data[property] = new Date(date.toUTCString().substr(0, 25));
			}
			if (options.datetimes.indexOf(property) !== -1) {
				data[property] = new Date(data[property]);
			}
		}
	}

	function paramsToQuery(params) {
		var result = '';
		var i = 0;

		if (params) {
			// eslint-disable-next-line no-unused-vars
			for (const param in params) {
				if (params[param] === null) {
					continue;
				}

				result += (i < 1) ? '?' : '&';
				result += param + '=' + encodeURIComponent(params[param]);
				i += 1;
			}
		}
		return result;
	}

	function rootUrl() {
		return appConfigService.get('serverPath') + baseUrl;
	}

	return {
		get: function (url, options) {
			return call('GET', url || '', '', options);
		},
		post: function (data, url, options) {
			return call('POST', url || '', data, options);
		},
		put: function (data, url, options) {
			return call('PUT', url || '', data, options);
		},
		delete: function (data, url, options) {
			return call('DELETE', url || '', data, options);
		},
		upload: upload,
		uploadFile: uploadFile,
		getParsed: getParsed,
		getParsedArray: getParsedArray,
		parse: parse,
		paramsToQuery: paramsToQuery,
		rootUrl: rootUrl
	};
}());